const routePermission = [
  {
    path: '/permission',
    name: 'Permission',
    component: () => import('@/pages/permission/PermissionPage'),
    meta: {
      layout: 'HomeLayout',
      user_info_route: false,
    },
  },
];

export default routePermission;
